export default "__VITE_ASSET__LbnNBHDi__"